import { ShoppingCartCheckout } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const Card = (props) => {
  return (
    <div
      className="dashboard-card-main flex-column justify-content-between"
      // style={{
      //   background: `${props?.bg}`,
      // }}
    >
      <div className="w-100 flex-row align-items-start justify-content-between ">
        <span>
          <h3 className="d-card-display-number">{props?.content}</h3>
          <h3 className="d-card-text">{props?.title}</h3>
        </span>

        <IconButton
          sx={{
            height: "5rem",
            width: "5rem",
            borderRadius: "8px",
            backgroundColor: "#00000030",
          }}
          style={{
            background: `${props?.bg}`,
          }}
        >
          {props?.icon}
        </IconButton>
      </div>
    </div>
  );
};

export default Card;
